import { z } from 'zod'
import { baseArticleObject, withRefinements } from '../../input/article-schema'
import { paginatedStateSchema } from '../base'

// -------------------------
// Articles State Validation
// -------------------------
export const articleStateItemSchema = withRefinements(
  baseArticleObject.extend({
    isSelected: z.boolean().optional()
  })
)

export const articleStateSchema = z.object({
  ...paginatedStateSchema.shape,
  items: z.array(articleStateItemSchema),
  selectedArticle: articleStateItemSchema.nullable()
})

// Separate action validation schema
export const articleActionSchema = {
  'articles/setArticles': z.array(articleStateItemSchema),
  'articles/updateArticle': articleStateItemSchema,
  'articles/setSelectedArticle': articleStateItemSchema.nullable(),
  'articles/setPagination': z.object({
    page: z.number(),
    limit: z.number(),
    total: z.number()
  }),
  'articles/setFilterParams': z.record(z.string(), z.unknown()).nullable()
} as const

// Type inference helpers
export type ArticleStateValidation = z.infer<typeof articleStateSchema>
